var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGl({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 81,
    viewBox: "0 0 47 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_146_119)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9262 52.677C28.5643 52.6717 33.0109 50.817 36.2905 47.52C39.5701 44.2229 41.4149 39.7526 41.4203 35.0899V19.9496H6.43213V35.0899C6.43834 39.7518 8.283 44.221 11.5617 47.5178C14.8404 50.8146 19.2856 52.6699 23.9228 52.677H23.9262ZM8.64113 21.9611H14.8183V23.3314H8.64113V21.9611ZM8.64113 26.9393H14.8183V28.3095H8.64113V26.9393ZM8.64113 31.8938H14.8183V33.264H8.64113V31.8938ZM8.64113 36.8719H14.8183V38.2421H8.64113V36.8719Z",
    fill: "#B4BBC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.569 1.80665e-05H0V35.1C0.00699392 40.6604 1.92599 46.0474 5.4318 50.3481C8.93762 54.6488 13.8146 57.5987 19.2364 58.698L19.3909 58.725V59.6363C19.3909 60.345 20.1529 60.9019 21.103 60.9019H22.5466V65.8159H22.0061C21.7606 65.8168 21.5254 65.9152 21.3519 66.0897C21.1783 66.2642 21.0804 66.5006 21.0795 66.7474V74.0104C21.0795 74.5234 21.4924 74.9351 21.9994 74.9351H22.5432V81H25.3296V74.9453H25.8735C26.119 74.9444 26.3541 74.846 26.5277 74.6715C26.7013 74.497 26.7992 74.2605 26.8001 74.0138V66.7406C26.7992 66.4939 26.7013 66.2575 26.5277 66.083C26.3541 65.9085 26.119 65.81 25.8735 65.8091H25.3296V60.8951H26.7732C27.7334 60.8951 28.4887 60.3349 28.4887 59.6295V58.7183C39.6042 56.4874 47.8661 46.764 47.8796 35.0966V-0.00335693L43.569 1.80665e-05ZM43.569 35.1C43.4756 40.2732 41.3664 45.2029 37.6949 48.8288C34.0234 52.4547 29.083 54.4871 23.9363 54.4889C18.7896 54.4906 13.8479 52.4616 10.1739 48.8383C6.49995 45.2149 4.38732 40.2866 4.29043 35.1135V4.32002H43.569V35.1Z",
    fill: "#B4BBC1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.64453 7.05377H14.8116V8.42402H8.64453V7.05377ZM8.64453 12.0285H14.8116V13.3988H8.64453V12.0285ZM8.64453 17.0066H14.8116V18.3769H8.64453V17.0066Z",
    fill: "#B4BBC1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_146_119"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 81,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGl);
export default __webpack_public_path__ + "static/media/gl.a5c9f30094043d0424685e61e2b0221c.svg";
export { ForwardRef as ReactComponent };